import React, { Component } from 'react';

class HaceGropper extends Component {
    render() {
        return (
            <div className="App">
            <a href="https://youtu.be/DnS9-V94hpg" target="_blank">
              <h2>Hace Gropper</h2>
            </a>
            <h4>
            JavaScript | Phaser | HTML | CSS | DOM | TypeScript
            </h4>
            <h5>educational first-person puzzle game</h5>
            <h5>
              collaborated with team to learn Phaser - an html-based game engine
              - and then design and code the central game map and sprite(game
              character)
            </h5>
            <h5>
              individually designed and coded a game map with integrated DOM
              minigame
            </h5>
            <h5>
              headed team CSS design and windows.localStorage implementation for
              consistent design and gameplay experience across maps
            </h5>
          </div>
            )}
}
export default HaceGropper